export enum PlayerParticipationAction {
    SET_PLAYER_PARTICIPATION = 'GET_PLAYER_PARTICIPATION'
  }
  
  export type PlayerParticipationType = {
    jerseyNumber: string, 
    name: string,
    nflId: string, 
    position: string, 
    positionGroup: string, 
    status: string, 
    tracking: boolean,
    ts: number
  }
  export interface PlayerParticipationState {
    [gameId: string]: PlayerParticipationType[];
  }
  
  interface UpdatePlayerParticipationData {
    type: PlayerParticipationAction.SET_PLAYER_PARTICIPATION,
    playerParticipationData: PlayerParticipationType[],
    gameId: string
  }
  
  export type PlayerParticipationActionTypes = UpdatePlayerParticipationData;